const AVENUE_POOL_SETTING_INFO = 'AVENUE_POOL_SETTING_INFO';
const AVENUE_POOL_SETTING_INFO_STEP = 'AVENUE_POOL_SETTING_INFO_STEP';
const AVENUE_POOL_SETTING_INFO_POOLID = 'AVENUE_POOL_SETTING_INFO_POOLID';
const AVENUE_POOL_EDIT_INFO_STEP = 'AVENUE_POOL_EDIT_INFO_STEP';

export function getAvenuePoolSettingInfo(payload) {
  return {
    type: AVENUE_POOL_SETTING_INFO,
    payload,
  };
}

export function getAvenuePoolSettingInfoStep(payload) {
  return {
    type: AVENUE_POOL_SETTING_INFO_STEP,
    payload,
  };
}

export function getAvenuePoolSettingInfoPoolId(payload) {
  return {
    type: AVENUE_POOL_SETTING_INFO_POOLID,
    payload,
  };
}

export function getAvenuePoolEditInfoStep(payload) {
  return {
    type: AVENUE_POOL_EDIT_INFO_STEP,
    payload,
  };
}

const intialPoolInfo = {
  info: false,
  current: 0,
  poolId: '',
  editCurrent: 0,
};

export default function avenuePoolSettingInfo(state = intialPoolInfo, action) {
  const { type, payload } = action;

  switch (type) {
    case AVENUE_POOL_SETTING_INFO:
      return Object.assign({}, state, { info: payload });
    case AVENUE_POOL_SETTING_INFO_STEP:
      return Object.assign({}, state, { current: payload });
    case AVENUE_POOL_SETTING_INFO_POOLID:
      return Object.assign({}, state, { poolId: payload });
    case AVENUE_POOL_EDIT_INFO_STEP:
      return Object.assign({}, state, { editCurrent: payload });
    default:
      return state;
  }
}
